import { render, staticRenderFns } from "./ModalDialog.vue?vue&type=template&id=c1047f30&scoped=true&"
import script from "./ModalDialog.vue?vue&type=script&lang=js&"
export * from "./ModalDialog.vue?vue&type=script&lang=js&"
import style0 from "./ModalDialog.vue?vue&type=style&index=0&id=c1047f30&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1047f30",
  null
  
)

export default component.exports